import CONSTANTS from "const/constants";

import SocialCredential from "./base";

const Globo = SocialCredential.extend({
    parse: function (response) {
        response = Globo.__super__.parse.apply(this, arguments);

        response.name = response.globoIntegrationName;
        response.typeLabel = `Globo`;
        response.platformType = `Globo account`;
        response.profileImage = `${CONSTANTS.CDN_URL}/static/img/social_icons/globo-logo.svg`;

        return response;
    }
});

export default Globo;
